import { render } from "./6Questionnaire2.vue?vue&type=template&id=7d527f97"
import script from "./6Questionnaire2.vue?vue&type=script&lang=js"
export * from "./6Questionnaire2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__